import React, { useState } from "react";
import { Skeleton } from "antd";

function ImageWithLoader({ src, alt = "", className = "", loading = "lazy" }) {
  const [loaded, setLoaded] = useState(false);

  if (!src) {
    return null;
  }

  return (
    <>
      {!loaded && <Skeleton.Image active className={className} />}

      <img
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        onLoad={() => {
          setLoaded(true);
        }}
        onError={() => console.log("Error loading image:", src)}
        style={{
          opacity: loaded ? 1 : 0,
          position: loaded ? "static" : "absolute",
        }}
      />
    </>
  );
}

export default ImageWithLoader;
